module.exports = __webpack_public_path__ + "static/media/play.719d0b69.svg";